import React, { useState } from "react";
import { Link } from "react-router-dom";
import JoinusModel from "../components/JoinusModel";
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const [isJoinUsModelOpen,setIsJoinUsModelOpen] = useState(false);
  function joinUs() {
      setIsJoinUsModelOpen(true);
  }
  const location = useLocation();
  return (
    <footer id="footer" className="flex justify-center md:mb-30px mb-2">
      <div className="w-full px-20px max-w-[1336px]">
        <div className="pb-[18px] lg:pb-[30px] flex gap-4 md:gap-16 lg:gap-[80px] xl:gap-[108px] relative flex-col md:flex-row lg-xl:justify-between justify-around md:items-end">
          <div className="space-y-5 lg-xl:max-w-[349px] max-w-full">
            <Link to="/">
              <img
                src="/hero-img.png"
                alt="fired up to vote"
                width={250}
                height={144}
                className="w-[220px] lg:w-[250px]"
              />
            </Link>
            <div>
              <span className="font-fira font-normal sm:text-22px text-18px leading-normal sm:leading-[35.2px] text-customRed">
                CONTACT
              </span>
              <span className="font-fira font-normal sm:text-22px text-18px leading-normal sm:leading-[35.2px] after:content-[':'] after:mx-1"></span>
              <a className="font-fira font-normal sm:text-22px text-18px leading-normal sm:leading-[35.2px] underline underline-offset-2" href="mailto:support@fireduptovote.com">support@fireduptovote.com</a>
            </div>
          </div>

          {location.pathname === '/' && (
          <div className="md:pb-12 lg-xl:max-w-[311px]">
              <span>
                <span className="font-fira font-semibold sm:text-22px text-18px leading-normal sm:leading-[35.2px] text-customRed underline underline-offset-2 cursor-pointer" onClick={() => joinUs()}>JOIN US</span>
                <span className="font-fira font-normal sm:text-22px text-18px leading-normal sm:leading-[35.2px]"> to educate and empower Harris County voters and increase voter turnout.</span>
              </span>
          </div>
          )}

          <div className="hidden lg-xl:block">
            <img
              src="/queue-for-voting.png"
              alt="queue for voting"
            />
          </div>
        </div>

        <div className="w-full h-[3px] border-t border-[#808080]"></div>
        <div className="flex items-center justify-between md:pt-30px pt-2 md:flex-row flex-col-reverse">
          <span className="font-fira font-normal sm:text-left text-justify lg:text-[20px] text-[16px] lg:leading-[26px] leading-normal sm:mt-0 mt-2">
            © Copyright 2025 | Fired Up To Vote All Rights Reserved | Website by <a href="https://astoundz.com/" target="blank">ASTOUNDZ</a> An SEO Company
          </span>
          <Link
            to="/privacy-policy"
            className="font-fira font-normal lg:text-[20px] text-[16px] lg:leading-[26px] leading-normal text-customRed underline"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
      {isJoinUsModelOpen && <JoinusModel closeModel={()=> setIsJoinUsModelOpen(false)}/> }
    </footer>
  );
};

export default Footer;
